import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SaveButton from "@/common/customer.additional-data-fields/SaveButton";
import OTCText from "@/common/customer/otc-text";
import ResendCode from "@/common/customer/buttons/resend-code";
import { getPlatform } from "@/hooks";

const { Customer, UI } = Mobi2Go;
const { getLoyaltyLinks, beginOptIn, completeOptIn } = Customer.ComoLoyalty;

const Como = ({ baseClass, closeModal }) => {
    const [links, setLinks] = useState({});
    const [t] = useTranslation('loyalty');
    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState('');
    const [codeSent, setCodeSent] = useState(false);

    useEffect(() => {
        getLoyaltyLinks().then(result => {
            setLinks(result);
        })
    }, [])

    const handleClick = () => {
        setIsLoading(true);

        codeSent
            ? handleVerify()
            : handleOptIn()
    }

    const handleOptIn = () => {
        beginOptIn()
            .then(action_required => {
                setIsLoading(false);
                if (action_required) {
                    setCodeSent(true);
                } else {
                    success();
                }
            })
    }

    const handleVerify = () => {
        completeOptIn(code)
            .then(() => {
                success();
            })
            .catch(() => {
                setIsLoading(false);
                UI.centeredAlert({
                    id: 'invalid-token',
                    title: t('verification_failure_alert_title'),
                    body: t('verification_failure_alert_body'),
                    temp: true
                });
            })
    }

    const success = () => {
        Customer.trigger('updateLoyalty');

        if (getPlatform() === 'web') {
            closeModal();
        } else {
            UI.trigger('showCustomerProfile');
        }
    }

    if (links === {}) return null;

    const isWeb = () => getPlatform() === 'web';

    return (
        <>
            <div
                className={`m2g-text${isWeb() ? '--small' : ''}`}
                style={{margin: '1em'}}
            >
                {t('opt_in_agree')}
                <a
                    href={links.termsOfUseUrl}
                    target={"_blank"}
                    className={baseClass('-password-prompt__link')}
                >
                    {t('terms_of_use')}
                </a>
                {", "}
                <a
                    href={links.privacyPolicyUrl}
                    target={"_blank"}
                    className={baseClass('-password-prompt__link')}
                >
                    {t('privacy_policy')}
                </a>
                {t('and')}
                <a
                    href={links.loyaltyTermsUrl}
                    target={"_blank"}
                    className={baseClass('-password-prompt__link')}
                >
                    {t('loyalty_terms_of_use')}
                </a>
            </div>

            {codeSent && (
                <>
                    <OTCText sent_to={Customer.getPhoneNumber()} />

                    <div
                        className={baseClass('-password m2g-input-container')}
                        data-icon-before
                    >
                        <span className="m2g-icon m2g-list-cell__icon m2g-icon--padlock" />
                        <input
                            type="text"
                            value={code}
                            placeholder={t('customer:login_otc_placeholder')}
                            className={baseClass(`-password-input m2g-list-cell__content ${isWeb() ? '' : 'm2g-touchable'}`)}
                            onChange={(e) => setCode(e.target.value)}
                            style={{marginLeft: isWeb() ? '1.7em' : ''}}
                        />
                    </div>


                </>
            )}

            <SaveButton
                handleSave={handleClick}
                text={t(codeSent ? 'verify_account_button' : 'opt_in_button')}
                baseClass={baseClass}
                saveButtonDisabled={isLoading}
            />

            {codeSent && <ResendCode email={Customer.getEmail()} send_sms={true} />}
        </>
    )
}

export default Como;
